module.exports = __webpack_public_path__ + "static/media/falguni_patil.edcb869f.jpg";